module.exports = __webpack_public_path__ + "staticfr/media/Controle-01.0b77137e.svg";